import { mapState, mapActions } from 'vuex';

import { API_URL } from '@services/api.service';

import { namespace as AppNamespace } from '@store/modules/app.types';
import { namespace as AuthNamespace, ActionTypes as AuthActionTypes } from '@store/modules/auth.types';

import { PROJECT_NAME } from '@config/application';

import { version as UI_VERSION } from '../../../package.json';

export default {
  name: 'AppLogin',
  data: () => ({
    API_URL,
    PROJECT_NAME,
    UI_VERSION,
    text: [
      'This system is owned by FarHeap Solutions, Inc. If you are not ',
      'authorized to access this system, exit immediately. ',
      'Unauthorized access to this system is forbidden by company policies, ',
      'national, and international laws. ',
      'Unauthorized users are subject to criminal and civil penalties as well ',
      'as company initiated disciplinary proceedings. ',
      'By entering this system you acknowledge that you have authorized access ',
      'and appropriate level of privilege within the system.',
    ].join(''),
    copyright: `© Opensoft - ${new Date().getFullYear()}`,
  }),
  computed: {
    ...mapState(AppNamespace, ['apiVersion', 'userManagerUrl']),
  },
  methods: {
    ...mapActions(AuthNamespace, { login: AuthActionTypes.LOGIN }),
  },
};
